import * as React from "react";
import Feed from "../../_data/models/Feed";
import * as moment from "moment";
import Style from "../../_data/models/Style";
import {getOwnerFromModel} from "../../_helpers/utils";
import {MouseEvent} from "react";
import UserRedirectContainer from "../../_widgets/user/UserRedirectContainer";
import ActivityFeedSpecialItemComponent from "./ActivityFeedSpecialItemComponent";
import Special from "../../_data/models/Special";
import Booth from "../../_data/models/Booth";
import {PrimaryModels} from "../../_definitions/styleteq";
import User from "../../_data/models/User";
import ActivityFeedBoothItemContainer from "../containers/ActivityFeedBoothItemContainer";
import ActivityFeedStyleItemComponent from "./ActivityFeedStyleItemComponent";
import ActivityFeedSpecialItemContainer from "../containers/ActivityFeedSpecialItemContainer";

interface Props {
    feed: Feed;
    model: PrimaryModels;
    user: User;
    viewFeed: () => void;
    toggleLike: (e: MouseEvent<HTMLElement>) => void;
}

const ActivityFeedItemComponent = (props: Props) => {
    const {feed, model, viewFeed, toggleLike} = props;
    const owner = getOwnerFromModel(model);

    return (
        <div className="newsfeed-panel callout paddingless mb-half">
            <div className="row p1 pb-0">
                <div className="large-12 columns">
                    <ul className="list-inline marginless">
                        <li>
                            <UserRedirectContainer id={owner.id} element="a">
                                <img src={owner.profilePicture()} className="img-wrapper circle"/>
                            </UserRedirectContainer>
                        </li>
                        <li>
                            <UserRedirectContainer id={owner.id} element="a">
                                <h5 className="inline">&nbsp;{owner.username()}</h5>
                            </UserRedirectContainer>
                            <label className="inline">&nbsp;posted a new {feed.resource}</label>
                        </li>
                        <li className="float-right ">
                            <label
                                className="inline post-time v-align-center">{moment(feed.createdAt).fromNow()}</label>
                        </li>
                    </ul>
                </div>
            </div>

            {feed.resource == 'style' &&
            <ActivityFeedStyleItemComponent style={model as Style} toggleLike={toggleLike} viewFeed={viewFeed}/>
            }

            {feed.resource == 'booth' &&
            <ActivityFeedBoothItemContainer booth={model as Booth}/>
            }

            {feed.resource == 'special' &&
            <ActivityFeedSpecialItemContainer special={model as Special} toggleLike={toggleLike}/>
            }
        </div>
    );
};
export default ActivityFeedItemComponent;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/components/ActivityFeedItemComponent.tsx